import { FORM_DATA_ACTION } from "../constant";

const initState = {
  previewData: null
};

export default function(state = initState, action) {
  switch (action.type) {
    /**
     *  CREATE PROJECT START
     */
    case FORM_DATA_ACTION.SET_PREVIEW_DATA:
      return {
        ...state,
        previewData: action.payload
      };

    case FORM_DATA_ACTION.CLEAR_PREVIEW_DATA: {
      return {
        ...state,
        previewData: null
      };
    }

    default:
      return state;
  }
}
